import { useIntl } from "react-intl";

import { AccountCreation } from "@/components/signup/account-creation/account-creation";
import {
    WhiteScreenInput,
    WhiteScreenLayout,
    WhiteScreenSocial,
    WhiteScreenSubmit
} from "@/components/signup/layouts/white-screen-layout";

export const LoggedOutJsmFree = () => {
    const { formatMessage } = useIntl();
    const heading1 = formatMessage(
        {
            id: "BxpUiSignup.SignupForm.header",
            defaultMessage: "Get started with {product}"
        },
        { product: "Jira Service Management" }
    );
    const heading2 = formatMessage({
        id: "BxpUiSignup.SignupForm.subheaderJSM",
        defaultMessage: "Free for up to 3 agents"
    });
    const helpText = formatMessage({
        id: "BxpUiSignup.SignupForm.workCallout",
        defaultMessage:
            "Find teammates, plus keep work and life separate by using your work email."
    });

    return (
        <WhiteScreenLayout heading1={heading1} heading2={heading2}>
            <AccountCreation
                Input={<WhiteScreenInput helpText={helpText} />}
                Social={<WhiteScreenSocial />}
                Submit={<WhiteScreenSubmit />}
            />
        </WhiteScreenLayout>
    );
};
